/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { rfqQuoteDetailsHeaderStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader";
import { css } from "styled-components";

rfqQuoteDetailsHeaderStyles.deleteQuoteButton = {
    css: css`
        display: none;
    `,
};
rfqQuoteDetailsHeaderStyles.submitQuoteButton = {
    css: css`
        display: none;
    `,
};
rfqQuoteDetailsHeaderStyles.declineQuoteButton = {
    css: css`
        display: none;
    `,
};
rfqQuoteDetailsHeaderStyles.acceptQuoteButton = {
    css: css`
        display: none;
    `,
};
rfqQuoteDetailsHeaderStyles.deleteQuoteClickable = {
    css: css`
        display: none;
    `,
};
rfqQuoteDetailsHeaderStyles.submitQuoteClickable = {
    css: css`
        display: none;
    `,
};
rfqQuoteDetailsHeaderStyles.declineQuoteClickable = {
    css: css`
        display: none;
    `,
};
rfqQuoteDetailsHeaderStyles.acceptQuoteClickable = {
    css: css`
        display: none;
    `,
};
